import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ChartConfiguration } from 'chart.js';
import { IReportFilter } from '../../utils/interfaces/report-filter';
import { PrintDocument } from '../print-document';
import { EngagementReportBodyComponent } from '../report-bodies/engagement-report-body.component';

@Component({
  selector: 'app-print-engagement',
  standalone: true,
  imports: [CommonModule, EngagementReportBodyComponent],
  template: `
    <app-engagement-report-body
      [data]="data"
      [filter]="filter"
      [print]="print"
    />
  `,
})
export class PrintEngagementComponent
  extends PrintDocument
  implements OnInit, AfterViewInit
{
  print = true;
  private readonly titleService = inject(Title);
  data!: ChartConfiguration<'bar'>['data'];
  filter!: IReportFilter;

  ngOnInit(): void {
    this.handleData();
  }

  ngAfterViewInit(): void {
    this.reportReadyData();
  }

  protected override handleData(): void {
    const { data, filter } = this.activatedRoute.snapshot.data['data'];

    this.data = data;
    this.filter = filter;

    this.titleService.setTitle(
      this.changeTitlePage(
        'Relatório de engajamento',
        this.filter.startDate,
        this.filter.finishDate
      )
    );
  }

  protected override reportReadyData(): void {
    setTimeout(() => {
      this.printDocumentService.onDataReady();
    }, 3000);
  }
}
